<template>
  <div class="content">
    <v-tabs v-model="tab">
      <v-tab to="users" v-if="canViewAllUsers">Gestion des utilisateurs</v-tab>
      <v-tab to="roles" v-if="canViewAllRoles">Gestion des rôles</v-tab>
      <v-tab to="federation" v-if="canViewAllFederations">Gestion des fédérations</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item id="users">
        <users />
      </v-tab-item>

      <v-tab-item id="roles">
        <roles />
      </v-tab-item>

      <v-tab-item id="federation">
        <federations />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import users from "./users";
import federations from "./federations";
import roles from "./roles";
import PermissionsService from "@/services/PermissionsService";
import { VTabs } from "vuetify/lib";

export default {
  props: ["tab"],

  components: {
    VTabs,
    federations,
    users,
    roles,
  },

  computed: {
    canViewAllRoles() {
      return PermissionsService.RolesPermissionsService.canViewAllRoles;
    },
    canViewAllUsers() {
      return PermissionsService.UsersPermissionsService.canViewAllUsers;
    },
    canViewAllFederations() {
      return PermissionsService.FederationsPermissionsService.canViewAllFederations;
    },
  },
};
</script>
